import React, { useEffect, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
// import LabelledBox from '../../../../../../../common/components/LabelledBox'
import { Box, Button } from "@mui/material";

import { useMrqContext } from "../../MrqContext";
import { useBOMDashboardContext } from "../../../BOMDashboard.context";
import AddPoModal from "./AddPoModal";
import {
  bulkDescriptionMrqMaterialsCols,
  bulkMrqMaterialsCols,
  mrqMaterialsCols,
  taggedMrqMaterialsCols,
} from "../../../Components/cols/mrqMaterialsCols";
import { mrqMaterialsMcsDataCols } from "../../../Components/cols/mrqMaterialsMcsCols";
import LabelledBox from "../../../../../../../../../components/widgets/LabelledBox";
import { lightTable } from "../../../../../../../../../styles/muiProps";
import { getUrlLink, onVisitUrl } from "../../../Components/getLink";
import { useNavigate } from "react-router-dom";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { useMcsContext } from "../../../../MCS.context";
import { secondAxios } from "../../../../../../../../../api/axios";
import { useParams } from "react-router-dom";

const MrqMaterialsTable = () => {
  const handleSaveItem = async (values) => {
    console.log({ values });
  };
  const { plantId } = useParams();
  const { plant } = useMcsContext();
  const { mrqData, isEditMode, onChangeCell } = useMrqContext();
  const { project } = useBOMDashboardContext();
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([]);

  const mrqMaterialsRowsWithoutSorting =
    mrqData?.mrqMaterials?.map((mm) => {
      if (mm?.materials?.[0].item) {
        return {
          ...mm,
          item: mm.materials[0].item,
          cost: mm?.poMaterials?.[0]?.cost || 0,
        };
      } else {
        return { ...mm, cost: mm?.poMaterials?.[0]?.cost || 0 };
      }
    }) || [];

  const mrqMaterialsRows = mrqMaterialsRowsWithoutSorting?.[0]?.item
    ? mrqMaterialsRowsWithoutSorting.sort((a, b) => a.item - b.item)
    : mrqMaterialsRowsWithoutSorting;
  // console.log('from mrqMaterials table : ', data);

  useEffect(() => {
    const getTasks = async () => {
      const res = await secondAxios.get("task/all/plant/" + plantId);
      // console.log("tasks in bid table", res);

      if (res.data) {
        const procurmentsTasks =
          res?.data?.filter((t) => t.type === "procurement") || [];
        setTasks(procurmentsTasks);
      }
    };

    getTasks();
  }, []);
  const generalTableAttrs = {
    data: mrqMaterialsRows,
    // enableRowSelection: isEditMode,

    positionActionsColumn: "last",
    onEditingRowSave: { handleSaveItem },

    ...lightTable,

    enableEditing: true,
    editDisplayMode: "cell",
  };

  const mcsCols = mrqMaterialsMcsDataCols.filter(
    (c) => !["mrqNumber", "srvNumber"].includes(c.accessorKey),
  );

  const descCols = bulkDescriptionMrqMaterialsCols(
    isEditMode,
    onChangeCell,
    tasks,
  ).filter((c) => !["wt"].includes(c.accessorKey));

  const isTaggedMaterials =
    mrqMaterialsRows?.some((row) =>
      row?.materials?.some((material) => material?.tagNumber),
    ) ?? false;

  const isBulkMaterials = mrqMaterialsRows?.[0]?.materialCode;

  const taggedTable = useMaterialReactTable({
    ...generalTableAttrs,
    columns: [
      ...taggedMrqMaterialsCols(isEditMode, onChangeCell, tasks),
      // ...mcsCols
    ],
  });

  const bulkTable = useMaterialReactTable({
    ...generalTableAttrs,
    columns: [
      ...bulkMrqMaterialsCols(isEditMode, onChangeCell, tasks),
      // ...mcsCols
    ],
  });

  const bulkDescriptionTable = useMaterialReactTable({
    ...generalTableAttrs,
    columns: [
      // ...bulkDescriptionMrqMaterialsCols,
      ...descCols,
      // ...mcsCols
    ],
  });

  const table = taggedTable;
  // isTaggedMaterials
  //   ? taggedTable
  //   : isBulkMaterials
  //     ? bulkTable
  //     : bulkDescriptionTable;

  return (
    <LabelledBox label="Mrq Materials" sx={{ width: "100%" }}>
      {/* <AddPoModal /> */}
      <MaterialReactTable table={table} />
    </LabelledBox>
  );
};

export default MrqMaterialsTable;
